<template>
  <b-row>
    <b-col xl="12" md="12" sm="12">
      <transition name="slide">
      <b-card :header="caption" >
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="matchesArray" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
          <template slot="localTeam" slot-scope="data">
            <strong>{{Object.values(data.item.val().localTeam)[0].name}}</strong>
          </template>
          <template slot="awayTeam" slot-scope="data">
            <strong>{{data.item.val().awayTeam.name}}</strong>
          </template>
          <template slot="result" slot-scope="data">
            <strong>{{Object.values(data.item.val().localTeam)[0].score}} : {{data.item.val().awayTeam.score}}</strong>
          </template>
          <template slot="date" slot-scope="data">
            <strong>{{data.item.val().date}}</strong>
          </template>
          <template slot="hour" slot-scope="data">
            <strong>{{data.item.val().hour}}</strong>
          </template>
          <template slot="created" slot-scope="data">
            {{new Date(data.item.val().created).toGMTString()}}
          </template>
          <template slot="modified" slot-scope="data">
            {{new Date(data.item.val().modified).toGMTString()}}
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="matchesArray.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          <b-row class="align-items-center">
            <b-col xl= "4" sm="6" md="4" class="mb-3 mb-xl-0" >
              <b-button v-on:click="addMatchButton" block variant="primary">Add Match</b-button>
            </b-col>
        </b-row>
        </nav>
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import { db } from '@/config/devowqlo';
export default {
  name: 'Matches',
  firebase: {
    matches: db.ref('teamMatches')
  },
  props: {
    caption: {
      type: String,
      default: 'Matches'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      //items: teamsData.filter((team) => team.id < 10),
      // items: [],
      // items: this.$firebaseRefs.teams,
      // items: this.getTeams(),
      fields: [
        {key: 'localTeam'},
        {key: 'awayTeam'},
        {key: 'result'},
        {key: 'date'},
        {key: 'created'},
        {key: 'modified'}
      ],
      matchesArray: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0
    }
  },
  created(){
      
      db.ref('teamMatches').on('value', (snapshot) =>{
        this.matchesArray = []
        console.log(snapshot.val())
        snapshot.forEach(childSnapshot => {
          console.log(childSnapshot.val())
          childSnapshot.forEach(matchSnapshot => {
            console.log(matchSnapshot.val())
            this.matchesArray.push(matchSnapshot)
          })
          //this.matchesArray.push(childSnapshot.val())
          //return childSnapshot.val()
        })
      })
  },
  methods: {
    showLocalTeam(item){
      console.log(Object.values(item.localTeam))
    },
    matchLink (id) {
      return `matches/${id}`
    },
    rowClicked (match) {

      console.log(match)
      const localTeamKey = Object.keys(match.val().localTeam)[0]
      console.log(localTeamKey)
      
      const matchLink = `matches/` + match.key + '&&' + localTeamKey
      this.$router.push({path: matchLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    addMatchButton () {
      this.$router.push({path: 'matches/addmatch'})
    }

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
